import React, { useCallback, useEffect, useState } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

async function fetchAutomationCoverageByEpic(queryString) {
  const url = `${QUALITY_SERVICE_API_URL}/hub/automation-coverage/by-epic?${queryString}`;
  console.log('[useAutomationCoverageByEpic] Fetching from:', url);
  try {
    const response = await api.get(url);
    console.log('[useAutomationCoverageByEpic] SUCCESS - Status:', response.status, 'Data:', response.data);
    return response.data;
  } catch (err) {
    console.error('[useAutomationCoverageByEpic] FAILED - Status:', err.response?.status, 'Error:', {
      status: err.response?.status,
      statusText: err.response?.statusText,
      message: err.message,
      data: err.response?.data,
      url: url,
    });
    throw err;
  }
}

function useAutomationCoverageByEpic(filters, scope = 'all', page = 1, pageSize = 50) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Log inputs
  React.useEffect(() => {
    console.log('[useAutomationCoverageByEpic] Hook called with:', {
      apiUrl: QUALITY_SERVICE_API_URL,
      filters,
      scope,
      page,
      pageSize,
    });
  }, [filters, scope, page, pageSize]);

  // Build query string
  const params = new URLSearchParams();
  params.set('scope', scope);
  
  ['domain', 'group', 'unit'].forEach(key => {
    (filters?.[key] || []).forEach(value => params.append(key, value));
  });
  
  if (page) params.set('page', page);
  if (pageSize) params.set('pageSize', pageSize);

  const queryString = params.toString();

  const fetchEpics = useCallback(async (isCancelled = () => false) => {
    console.log('[useAutomationCoverageByEpic] Starting fetch with query:', queryString);
    setLoading(true);
    setError(null);
    setData(null);
    try {
      const epic_data = await fetchAutomationCoverageByEpic(queryString);
      console.log('[useAutomationCoverageByEpic] Fetch succeeded, got data:', epic_data);
      if (!isCancelled()) setData(epic_data);
    } catch (err) {
      console.error('[useAutomationCoverageByEpic] Fetch failed:', err);
      if (!isCancelled()) setError(err);
    } finally {
      if (!isCancelled()) setLoading(false);
    }
  }, [queryString]);

  useEffect(() => {
    let cancelled = false;
    fetchEpics(() => cancelled);
    return () => { cancelled = true; };
  }, [fetchEpics]);

  return { data, loading, error, refetch: () => fetchEpics() };
}

export default useAutomationCoverageByEpic;
